import en from './en-US';
import fr from './fr-CA';

export default {
    ...en,
    ...fr,
}